import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQuery } from 'react-query';
import { QueryKey } from '../../domain/dtos/query-keys.js';
import { GetCollaborator } from '../../usecases/get-collaborator.js';

const useGetCollaborator = collaboratorUserId => {
  const container = useContainer();
  return useQuery([QueryKey.getMyCollaborator], () => new GetCollaborator(container.get(HttpClient)).execute(collaboratorUserId), {
    retry: false,
    retryOnMount: false,
    refetchOnWindowFocus: false,
    initialData: null
  });
};

export { useGetCollaborator };
